// @flow

import {getDataTotalLength} from '@pb/kit-component-tree-v2';

import {getCheckedChildrenState} from './getCheckedChildrenState';

import type {TreeStructure} from '@pb/kit-component-tree-v2';

import type {CheckedTree} from '../typedef';


export const parseCheckedIds = (data: TreeStructure, checkedIdsList: Array<string>): CheckedTree =>
    data.reduce((acc, item) => {
        let children = {};
        const total = getDataTotalLength(item.children || []);
        let checked = 0;
        if (item.children) {
            children = parseCheckedIds(item.children, checkedIdsList);
        }

        // A transient node is a non-selectable group header (rendered as a
        // Label, not a checkbox), so its own checked state is never read. But it
        // still participates in checked-tree accounting: it is treated as a
        // regular parent whose checked/indeterminate state is derived from its
        // children. This lets a transient node with children propagate its
        // selection state up to its parent.
        if (checkedIdsList.includes(item.id) || Object.keys(children).length) {
            Object.keys(children).forEach(currId => {
                checked = children[currId].indeterminate ? checked : ++checked;
            });
            acc[item.id] = getCheckedChildrenState(total, checked, children);
        }
        return acc;
    }, {});
